import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAdminWebsite } from 'utils';
import { StyledHeader, StyledButton, StyledBadge, StyledDot } from './Logo.styled';

const isLocal = ['local', 'stg'].includes(process.env.REACT_APP_ENVIRONMENT);

const Logo = ({ admin, menuCollapsed, toggleCollapsingMenu, setAdmin }) => {
    useEffect(() => {
        setAdmin(getAdminWebsite());
    }, [setAdmin]);

    function handleToggleMenu() {
        toggleCollapsingMenu();
    }

    return (
        <StyledHeader className="gx-layout-sider-header">
            <StyledButton
                type="dashed"
                theme="lite"
                onClick={handleToggleMenu}
            >
                <i className={`la la-toggle-${menuCollapsed ? 'right' : 'left'} gx-text-black`} />
            </StyledButton>

            <Link to="/dashboard" className="gx-site-logo">
                <img src={`${process.env.REACT_APP_CDN}admin/logos/${admin}.png`} alt="" />
            </Link>

            {
                isLocal && <StyledDot title={`${process.env.REACT_APP_ENVIRONMENT.toUpperCase()} v${process.env.REACT_APP_VERSION}`}><StyledBadge color="gold" status="processing" /></StyledDot>
            }
        </StyledHeader>
    );
};

export default Logo;
